import httpRequest from '@packages/components/upload/components/src/ajax'
import {
  options
} from './options'

export default opts => {
  options.httpRequest.getServerConfig().then(data => {
    opts.action = data.zoneUrl
    Object.assign(opts.data, {
      token: data.token
    })

    let onSuccess = opts.onSuccess
    opts.onSuccess = function (res) {
      onSuccess(Object.assign({}, data, res))
    }

    return httpRequest(opts)
  })
}



// WEBPACK FOOTER //
// ./src/packages/third/qiniu/qiniuHttpRequest.js